import { baseExtensions } from '@shared/messaging/src/RichTextHelper'

export const extensions = baseExtensions
